var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentAffairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252525;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.35,4h-4V1.88A1.65,1.65,0,0,0,16.71.24H1.65A1.65,1.65,0,0,0,0,1.88V22.12a1.65,1.65,0,0,0,1.65,1.64H20.48A3.52,3.52,0,0,0,24,20.25V5.65A1.65,1.65,0,0,0,22.35,4ZM1.65,22.35a.23.23,0,0,1-.24-.23V1.88a.23.23,0,0,1,.24-.23H16.71a.23.23,0,0,1,.23.23V20.24a3.53,3.53,0,0,0,.71,2.11Zm20.94-2.11a2.11,2.11,0,0,1-2.11,2.11h0a2.11,2.11,0,0,1-2.11-2.11V5.41h4a.23.23,0,0,1,.24.23Zm-8.71-7.32H4.47a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.71h9.41a.71.71,0,0,0,.71-.71A.7.7,0,0,0,13.88,12.92Zm0,3.76H4.47a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.71h9.41a.71.71,0,0,0,.71-.71A.7.7,0,0,0,13.88,16.68Zm0-11.27H4.47a.7.7,0,0,0-.7.7V9.88a.7.7,0,0,0,.7.7h9.41a.7.7,0,0,0,.71-.7V6.12A.71.71,0,0,0,13.88,5.41Zm-.7,3.76h-8V6.82h8V9.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentAffairs);
export default __webpack_public_path__ + "static/media/currentAffairs.3e1b19bde9264729ab4c58cf2516a10b.svg";
export { ForwardRef as ReactComponent };